import React, { useState } from 'react'
import styled from 'styled-components'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

const CloseIncidentDialog = ({
  open,
  incidentTitle,
  openActionsCount = 0,
  onCancel,
  onConfirm,
}) => {
  const [busy, setBusy] = useState(false)
  const hasOpen = openActionsCount > 0

  const handleConfirm = async () => {
    if (busy) return
    setBusy(true)
    try {
      await onConfirm()
    } finally {
      setBusy(false)
    }
  }

  return (
    <Dialog open={open} onClose={busy ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: 16, fontWeight: 600, pb: 1 }}>
        Close this incident?
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Lead>
          {incidentTitle
            ? <>You're closing <strong>"{incidentTitle}"</strong>.</>
            : <>You're closing this incident.</>}
        </Lead>

        {hasOpen ? (
          <Para>
            It still has <strong>{openActionsCount} open remedial{openActionsCount === 1 ? '' : 's'}</strong>{' '}
            that came out of it. {openActionsCount === 1 ? 'It stays' : 'They stay'} open until{' '}
            {openActionsCount === 1 ? 'it is' : 'they are'} marked as complete or turned into{' '}
            {openActionsCount === 1 ? 'a task' : 'tasks'}. Closing the incident does not change{' '}
            {openActionsCount === 1 ? 'it' : 'them'}.
          </Para>
        ) : (
          <Para>This incident has no open remedials left, so closing won't affect anything else.</Para>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <SecondaryBtn type="button" onClick={onCancel} disabled={busy}>Cancel</SecondaryBtn>
        <PrimaryBtn type="button" onClick={handleConfirm} disabled={busy}>
          {busy ? 'Closing…' : 'Close incident'}
        </PrimaryBtn>
      </DialogActions>
    </Dialog>
  )
}

export default CloseIncidentDialog

const Lead = styled.p`
  margin: 0 0 8px 0;
  font-size: 13px;
  color: #0f172a;
  strong { font-weight: 600; }
`

const Para = styled.p`
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
  strong { color: #0f172a; font-weight: 600; }
  em { font-style: italic; color: #0f172a; }
`

const Btn = styled.button`
  min-height: 40px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  &:disabled { opacity: 0.5; cursor: progress; }
`

const SecondaryBtn = styled(Btn)`
  background: white;
  border: 1px solid #e5e7eb;
  color: #475569;
  &:hover:not(:disabled) { background: #f8fafc; }
`

const PrimaryBtn = styled(Btn)`
  background: #D24724;
  border: 1px solid #D24724;
  color: white;
  &:hover:not(:disabled) { background: #b53a1d; border-color: #b53a1d; }
`
